import {AfterViewInit, Component, Injector, Input, OnDestroy, OnInit, StaticProvider, ViewChild} from '@angular/core';
import {WizardInformacion} from "../../interface/wizard-informacion.types";
import {DynamicContainerDirective} from "../base/dynamic-container.directive";
import {SectionComponent} from "../section/section.component";
import {ComponentPortal, Portal} from "@angular/cdk/portal";
import {WIZARD_DATA} from "../../tokens/tokens";
import {DataWizardService} from '../../services/data-wizard.service';

@Component({
    selector: 'lib-container',
    templateUrl: './container.component.html',
    styleUrls: ['./container.component.css']
})
export class ContainerComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild(DynamicContainerDirective, {static: false}) container;

    @Input()
    informacionWizard: WizardInformacion;

    @Input()
    biosphereConfig: any;

    @Input()
    descargaZipByFolio: boolean;
    
    @Input()
    skipByVersion: boolean;

    @Input()
    set current(step) {
        if (step != null && this.currentStep != step) {
            this.currentStep = step;
            if (this.isAfter) {
                this.loadComponentPortal();
            }
        }
    };

    @Input()
    readOnly;

    selectedPortal: Portal<any>;

    currentStep;

    isAfter = false;

    constructor(
        public injector: Injector,
        public dataWizardService: DataWizardService
    ) {
    }

    ngOnInit(): void {

    }

    ngAfterViewInit() {
        this.isAfter = true;
        this.loadComponentPortal()
    }

    async loadComponentPortal() {
        if (this.selectedPortal) {
            this.selectedPortal.detach();
        }
        const viewContainerRef = this.container.viewContainerRef;
        const data = {
            paso: this.informacionWizard.pasos[this.currentStep],
            idWizard: this.informacionWizard.idWizardGenerado,
            readOnly: this.readOnly,
            biosphereConfig: this.biosphereConfig,
            descargaZipByFolio: this.descargaZipByFolio,
            skipByVersion: this.skipByVersion,
        }
        const componentPortal = new ComponentPortal(SectionComponent, viewContainerRef, this.createInjector(data));
        setTimeout(() =>
            this.selectedPortal = componentPortal
        );
    }

    createInjector(data) {
        const providers: StaticProvider = [
            {provide: WIZARD_DATA, useValue: data}
        ];
        return Injector.create({parent: this.injector, providers})
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    ngOnDestroy(): void {
        this.dataWizardService.stopSubscriptions();
    }
}
